"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFetchFuturesOrderCost = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _actions = require("../../../../redux/futures/actions");
var _instrumentPositionSelectors = require("../../../../redux/selectors/instrumentPositionSelectors");
var _futuresLeverageSelectors = require("../../../../redux/futures/selectors/futuresLeverageSelectors");
var _hooks = require("../../hooks");
var _orderHelper = require("../../../../helpers/orderHelper");
var _FuturesOrderEntryFormContainer = require("../FuturesOrderEntryForm/FuturesOrderEntryFormContainer");
var _selectors = require("../../../../redux/futures/selectors");
var GET_FUTURES_ORDR_COST_DEBOUNCE_DELAY = 200;
var useFetchFuturesOrderCost = exports.useFetchFuturesOrderCost = function useFetchFuturesOrderCost() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var instrument = (0, _reactRedux.useSelector)(_instrumentPositionSelectors.selectedInstrumentSelector);
  var formValues = (0, _hooks.useFormValues)(_FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME);
  var leverage = (0, _reactRedux.useSelector)(_futuresLeverageSelectors.currentFuturesLeverageSelector);
  var bestAskPrice = (0, _reactRedux.useSelector)(_selectors.futuresInstrumentBestAskPriceSelector);
  var bestBidPrice = (0, _reactRedux.useSelector)(_selectors.futuresInstrumentBestBidPriceSelector);
  var futuresEntryPrice = (0, _orderHelper.getFuturesOrderEntryPrice)(formValues, bestAskPrice);
  var futuresReferencePrice = (0, _orderHelper.getFuturesReferencePrice)(formValues, bestBidPrice);
  (0, _react.useEffect)(function () {
    var instrumentId = instrument === null || instrument === void 0 ? void 0 : instrument.InstrumentId;
    var isByOrderQuantity = (instrument === null || instrument === void 0 ? void 0 : instrument.Product1Symbol) === (formValues === null || formValues === void 0 ? void 0 : formValues.orderByProduct);
    if (!instrumentId || !(formValues !== null && formValues !== void 0 && formValues.quantity) || !futuresReferencePrice || !futuresEntryPrice || !leverage) return;
    var timer = setTimeout(function () {
      dispatch((0, _actions.GetFuturesOrderCost)(instrument === null || instrument === void 0 ? void 0 : instrument.InstrumentId, formValues === null || formValues === void 0 ? void 0 : formValues.quantity, futuresEntryPrice, futuresReferencePrice, leverage, isByOrderQuantity));
    }, GET_FUTURES_ORDR_COST_DEBOUNCE_DELAY);
    return function () {
      return clearTimeout(timer);
    };
  }, [dispatch, instrument === null || instrument === void 0 ? void 0 : instrument.InstrumentId, formValues === null || formValues === void 0 ? void 0 : formValues.quantity, futuresEntryPrice, futuresReferencePrice, leverage, formValues === null || formValues === void 0 ? void 0 : formValues.orderByProduct, instrument === null || instrument === void 0 ? void 0 : instrument.Product1Symbol]);
};